import { useContext, useEffect, useRef } from "react";
import { formatDate } from "../../utils";
import type { MiniPostInList } from "../../utils/api-types";
import { ClientLinkContext } from "../Layouts";
import { EntryListItem } from "./EntryListItem";

export interface EntryListProps {
  activeSlug?: string;
  basePath?: string;
  data?: MiniPostInList[];
}

export const EntryList = ({ activeSlug = "", basePath = "", data = [] }: EntryListProps) => {
  // Scroll into view only once onMount, not on subsequent rerenders.
  const calledOnce = useRef(false); // ?? useRef(!activeSlug)
  useEffect(() => {
    if (calledOnce.current) {
      return;
    }
    if (!!activeSlug) {
      calledOnce.current = true;
    }
  }, [activeSlug]);
  //////

  const OUTER_X_CSS = "px-3";

  const CustomLink = useContext(ClientLinkContext);

  return (
    <div className={OUTER_X_CSS}>
      <hr className={`border-t-2 border-e-color-onSurface mb-2 mx-2`} />
      {data.map((item) => {
        const isActive = activeSlug === item.slug;
        const props = {
          isActive,
          scrollToMe: isActive && !calledOnce.current,
          title: item.title,
          href: `/${basePath}${basePath ? "/" : ""}${item.slug}`,
          byline: item.createdAt ? formatDate(item.createdAt) : undefined,
          CustomLink,
        };
        return <EntryListItem key={item.slug} {...props} />;
      })}
    </div>
  );
};
